(() => {
  if (window.leivipVideosGuideNavigationInstalled) return;
  window.leivipVideosGuideNavigationInstalled = true;
  window.addEventListener('click', event => {
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    if (!(event.target instanceof Element)) return;
    const link = event.target.closest('leivip-videos-page .question-nav a[href^="#"]');
    if (!link) return;
    const root = link.closest('leivip-videos-page');
    const href = link.getAttribute('href');
    const target = document.getElementById(href.slice(1));
    if (!target || !root.contains(target)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (!window.Shopify?.designMode) history.pushState(null, '', href);
    if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
    target.focus({ preventScroll: true });
    const heading = target.querySelector('h3') || target;
    heading.scrollIntoView({ behavior: 'instant', block: 'start' });
    // The inherited header changes height after scrolling in the theme editor.
    // Correct the landing after that layout update, using the visible heading.
    let attempts = 0;
    const settleLanding = () => {
      if (document.activeElement !== target) return;
      const header = document.getElementById('shopify-section-header');
      const headerBottom = header ? Math.max(0, header.getBoundingClientRect().bottom) : 0;
      const desiredTop = headerBottom + 128;
      const top = heading.getBoundingClientRect().top;
      if (Math.abs(top - desiredTop) > 1) window.scrollBy({ top: top - desiredTop, behavior: 'instant' });
      if (++attempts < 6) window.requestAnimationFrame(settleLanding);
    };
    window.requestAnimationFrame(settleLanding);
  }, { capture: true });
})();
